export default "__VITE_ASSET__DYRPESRw__"